import apiClient from './apiClient';

// Auth API endpoints

// Admin login — credentials sent, server sets httpOnly cookies in response
export const login = async (credentials) => {
  const response = await apiClient.post('/auth/admin/login', {
    ...credentials,
    userType: 'ADMIN'
  });
  return response.data;
};

// Silent refresh — sends adminRefreshToken cookie, receives new adminAccessToken cookie
export const refreshAdminToken = async () => {
  const response = await apiClient.post('/auth/admin/refresh-token');
  return response.data;
};

// Logout — server clears both cookies
export const logout = async () => {
  const response = await apiClient.post('/auth/logout');
  return response.data;
};

// Verify session by fetching profile (cookie sent automatically)
export const getProfile = async () => {
  const response = await apiClient.get('/auth/profile');
  return response.data;
};

export const forgotPassword = async (email) => {
  const response = await apiClient.post('/auth/admin/forgot-password', { email });
  return response.data;
};

export const verifyOtp = async (email, otp) => {
  const response = await apiClient.post('/auth/admin/verify-otp', { email, otp });
  return response.data;
};

export const resetPassword = async (email, password, confirmPassword) => {
  const response = await apiClient.post('/auth/admin/reset-password', { email, password, confirmPassword });
  return response.data;
};

export const updateProfile = async (profileData) => {
  const response = await apiClient.put('/auth/profile', profileData);
  return response.data;
};

export const changePassword = async (passwordData) => {
  const response = await apiClient.put('/auth/change-password', passwordData);
  return response.data;
};

export default apiClient;